import { render, staticRenderFns } from "./TicketLookup.vue?vue&type=template&id=1a52b73e&scoped=true"
import script from "./TicketLookup.vue?vue&type=script&lang=js"
export * from "./TicketLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a52b73e",
  null
  
)

export default component.exports